export const Notification = {
  namespaced: true,
  state: {
    notifications: [
      "Emitir formulários.",
      "Emitir formulários e o MO29300.",
      "Emitir DAMP(s)/MO29300 (Verificar autorização de FGTS do cliente na pasta/SIOPI, extrato analítico).",
      "Solicitar/Verificar a guia de ITBI/emissão de certidões para registro.",
      "Adiantar/Finalizar a proposta no SIOPI/SICTD.",
      "Carimbar os formulários e verificar o complemento pendente para transmissão do dossiê para a conformidade.",
      "Verificar o complemento pendente para transmissão do dossiê para a conformidade.",
      "Enviar os formulários emitidos para o cliente.",
      "Enviar os formulários e o MO29300 emitidos para o cliente.",
      "Enviar os formulários e a DAMP(s)/MO29300 emitidos para o cliente.",
      "Carimbar os formulários recebidos.",
      "Solicitar/Verificar autorização de FGTS no App do FGTS e extrato analítico.",
      "Solicitar/Verificar tela PDL/Saldo devedor.",
      "Incluir formulários carimbados no SICTD.",
      "Proposta enquadrada na modalidade de recursos originados do FGTS. Verificar se possui imóvel e/ou financiamento ativo no SFH (anotar no app se for necessário).",
      "Proposta com utilização de FGTS. Verificar se possui imóvel e/ou financiamento ativo no SFH (anotar no app se for necessário).",
      "Montar dossiê físico para envio à agência.",
      "Emitir e enviar os formulários do(s) vendedor(es).",
    ],
  },
  getters: {
    notifications: (state) => state.notifications,
  },
  mutations: {},
};
